import { render } from "./NotificationsDropdown.vue?vue&type=template&id=e15ea242&scoped=true"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts"

import "./NotificationsDropdown.vue?vue&type=style&index=0&id=e15ea242&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e15ea242"

export default script